exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5a43e18a] .avue-crud__right {\n  display: none;\n}", ""]);

// exports
